module.exports = __webpack_public_path__ + "static/media/bm.d7ea11b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bm.png
// module id = 1801
// module chunks = 0